/**
 * Guest routes: routes that do not need authentication
 * (login, welcome etc).
 *
 * Will me merged into the router's 'route' array
 */
// import { getI18nInstance } from '@/i18n';

// import Login from '@/views/guest/Login.vue';
// import Publication from '@/views/guest/Publication.vue';
// import Behoerdenverzeichnis from '@/views/guest/Behoerdenverzeichnis.vue';
// import BehoerdenverzeichnisForm from '@/views/guest/BehoerdenverzeichnisForm.vue';
import Help from '@/views/HelpView.vue';
import HelpFaq from '@/views/HelpFaq.vue';
import HelpContact from '@/views/HelpContact.vue';
import Impressum from '@/views/ImpressumView.vue';
import { getI18n } from '@/helpers/i18n';

const routes = [
    // {
    //     path: '/publication',
    //     name: 'publication',
    //     component: Publication,
    //     meta: {
    //         guest: true,
    //         title: 'publication'
    //     }
    // },
    // {
    //     path: '/behoerdenverzeichnis',
    //     name: 'behoerdenverzeichnis',
    //     component: Behoerdenverzeichnis,
    //     meta: {
    //         guest: true,
    //         title: 'behoerdenverzeichnis'
    //     }
    // },
    // {
    //     path: '/behoerdenverzeichnis/:id',
    //     name: 'behoerdenverzeichnis_form',
    //     component: BehoerdenverzeichnisForm,
    //     meta: {
    //         guest: true,
    //         title: (to) => getI18nInstance().t('stelle') + `: ${to.params.id}`
    //     }
    // },
    {
        path: '/help',
        name: 'help',
        component: Help,
        meta: {
            guest: true,
            title: () => getI18n().t('help'),
            breadcrumbTo: { name: 'help-faq' }
        },
        children: [
            {
                path: 'faq',
                name: 'help-faq',
                component: HelpFaq,
                meta: {
                    guest: true,
                    title: () => getI18n().t('fragen_amp_antworten')
                }
            },
            {
                path: 'contact',
                name: 'help-contact',
                component: HelpContact,
                meta: {
                    guest: true,
                    title: () => getI18n().t('kontakt')
                }
            }
        ]
    },
    // {
    //     path: '/login',
    //     name: 'login',
    //     component: Login,
    //     meta: {
    //         guest: true,
    //         title: 'Anmelden'
    //     }
    // },
    {
        path: '/impressum',
        name: 'impressum',
        component: Impressum,
        meta: {
            guest: true,
            title: 'impressum'
        }
    }
];

export default routes;
